import { render, staticRenderFns } from "./DeviceInformation.vue?vue&type=template&id=28732d04&scoped=true"
import script from "./DeviceInformation.vue?vue&type=script&lang=js"
export * from "./DeviceInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28732d04",
  null
  
)

export default component.exports